module.exports = __webpack_public_path__ + "img/LogoVapzaRel.b9e03ff7.png";